import React from "react";
import styled from "styled-components";
import { Col, Row } from "components/bootstrap";
import { Wizard } from "components/common";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "logic/telemetry/Constants";
import EventDefinitionFormControls from "components/event-definitions/event-definition-form/EventDefinitionFormControls";
const WizardContainer = styled.div`
  margin-bottom: 10px;
`;
const STEP_KEYS = {
  EVENT_DETAILS: "event-details",
  CONDITION: "condition",
  ADDITIONAL_DETAILS: "additional-details",
  NOTIFICATIONS: "notifications",
  SHARE: "Share",
  SUMMARY: "summary"
};
export const getStepKeys = (isNew, hideFieldsStep = false) => [
  STEP_KEYS.EVENT_DETAILS,
  STEP_KEYS.CONDITION,
  ...hideFieldsStep ? [] : [STEP_KEYS.ADDITIONAL_DETAILS],
  STEP_KEYS.NOTIFICATIONS,
  ...isNew ? [STEP_KEYS.SHARE] : [],
  STEP_KEYS.SUMMARY
];
const LEGACY_STEP_KEYS = {
  fields: STEP_KEYS.ADDITIONAL_DETAILS
};
export const normalizeStepKey = (step) => {
  var _a;
  return step ? (_a = LEGACY_STEP_KEYS[step]) != null ? _a : step : step;
};
const STEP_TELEMETRY_KEYS = [
  TELEMETRY_EVENT_TYPE.EVENTDEFINITION_DETAILS.STEP_CLICKED,
  TELEMETRY_EVENT_TYPE.EVENTDEFINITION_CONDITION.STEP_CLICKED,
  TELEMETRY_EVENT_TYPE.EVENTDEFINITION_FIELDS.STEP_CLICKED,
  TELEMETRY_EVENT_TYPE.EVENTDEFINITION_NOTIFICATIONS.STEP_CLICKED,
  TELEMETRY_EVENT_TYPE.EVENTDEFINITION_SUMMARY.STEP_CLICKED
];
const EventDefinitionForm = ({
  steps,
  action = "edit",
  activeStep,
  formControls: FormControls = EventDefinitionFormControls,
  onCancel,
  onChangeStep,
  onSubmit
}) => {
  const sendTelemetry = useSendTelemetry(action === "create" ? "new-event-definition" : "edit-event-definition");
  const handleSubmit = (event) => {
    if (event) {
      event.preventDefault();
    }
    onSubmit();
  };
  const currentStepKeys = steps.map((step) => step.key);
  const activeStepIndex = currentStepKeys.indexOf(activeStep);
  const handleStepChange = (nextStep) => {
    var _a;
    sendTelemetry(STEP_TELEMETRY_KEYS[currentStepKeys.indexOf(nextStep)], {
      app_action_value: "event-definition-step",
      current_step: (_a = steps[activeStepIndex]) == null ? void 0 : _a.title
    });
    onChangeStep(nextStep);
  };
  const openPrevPage = () => {
    var _a;
    sendTelemetry(TELEMETRY_EVENT_TYPE.EVENTDEFINITION_PREVIOUS_CLICKED, {
      app_action_value: "previous-button",
      current_step: (_a = steps[activeStepIndex]) == null ? void 0 : _a.title
    });
    const previousStep = activeStepIndex > 0 ? currentStepKeys[activeStepIndex - 1] : void 0;
    onChangeStep(previousStep);
  };
  const openNextPage = () => {
    var _a;
    sendTelemetry(TELEMETRY_EVENT_TYPE.EVENTDEFINITION_NEXT_CLICKED, {
      app_action_value: "next-button",
      current_step: (_a = steps[activeStepIndex]) == null ? void 0 : _a.title
    });
    const nextStep = currentStepKeys[activeStepIndex + 1];
    onChangeStep(nextStep);
  };
  return /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(WizardContainer, null, /* @__PURE__ */ React.createElement(
    Wizard,
    {
      steps,
      activeStep,
      onStepChange: handleStepChange,
      horizontal: true,
      justified: true,
      containerClassName: "",
      hidePreviousNextButtons: true
    }
  )), /* @__PURE__ */ React.createElement(
    FormControls,
    {
      activeStepIndex,
      action,
      onOpenPrevPage: openPrevPage,
      onOpenNextPage: openNextPage,
      steps,
      onSubmit: handleSubmit,
      onCancel
    }
  )));
};
export default EventDefinitionForm;
